"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var GridColumn_1 = require("./GridColumn");

var GridRow_1 = require("./GridRow");

var Sizes;

(function (Sizes) {
  Sizes["FULL"] = "";
  Sizes["HALF"] = "lsg--grid-column__half";
  Sizes["THIRD"] = "lsg--grid-column__third";
  Sizes["QUARTER"] = "lsg--grid-column__quarter";
})(Sizes || (Sizes = {}));

exports.Sizes = Sizes;
var TextAlign;

(function (TextAlign) {
  TextAlign["LEFT"] = "lsg--grid__left";
  TextAlign["CENTER"] = "lsg--grid__center";
  TextAlign["RIGHT"] = "lsg--grid__right";
})(TextAlign || (TextAlign = {}));

exports.TextAlign = TextAlign;
var VerticalAlign;

(function (VerticalAlign) {
  VerticalAlign["TOP"] = "lsg--grid__top";
  VerticalAlign["MIDDLE"] = "lsg--grid__middle";
  VerticalAlign["BOTTOM"] = "lsg--grid__bottom";
  VerticalAlign["JUSTIFY"] = "lsg--grid__justify";
})(VerticalAlign || (VerticalAlign = {}));

exports.VerticalAlign = VerticalAlign;
var Spacing;

(function (Spacing) {
  Spacing["SECTION"] = "lsg--grid__sectionSpacing";
  Spacing["HALF_SECTION"] = "lsg--grid__halfSectionSpacing";
  Spacing["CONTAINER"] = "lsg--grid__containerSpacing";
  Spacing["GALLERY"] = "lsg--grid__gallerySpacing";
})(Spacing || (Spacing = {}));

exports.Spacing = Spacing;

exports.Grid = function (_a) {
  var children = _a.children,
      verticalSpacing = _a.verticalSpacing,
      marginTop = _a.marginTop,
      marginBottom = _a.marginBottom;
  return React.createElement("div", {
    className: utils_1.DomUtils.cleanupClassNames(["lsg--grid", verticalSpacing && verticalSpacing + "-vertical", marginTop && marginTop + "-marginTop", marginBottom && marginBottom + "-marginBottom"])
  }, children);
};

exports.Grid.Sizes = Sizes;
exports.Grid.VerticalAlign = VerticalAlign;
exports.Grid.TextAlign = TextAlign;
exports.Grid.Spacing = Spacing;
exports.Grid.Row = GridRow_1.GridRow;
exports.Grid.Column = GridColumn_1.GridColumn;
exports.Grid.displayName = "Grid";